import type { FaireProductEntity } from "../../entity_types/product";

export const p_mdzwes5fgm: FaireProductEntity = {
  token: "p_mdzwes5fgm",
  type: "product",
  name: "Wholesale Discovery Kit - Lips (Full size Trial)",
  brandToken: "b_3d2wzlqi",
  brandName: "River Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/5a55d67708b1990bfc06e6591d334164a19d0c4ac0af81171921ccb6045b1822.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d48638a736922889f18610f4ec9325730e4ae0e00e5f946de8f0c943981dbf05.jpeg",
    "https://cdn.faire.com/fastly/0374340d255bce39e86af3e9421f06b2327dbd1330a4fdbfcce9f0d885cc154e.png",
    "https://cdn.faire.com/fastly/6dc337a41661661be0976f82dc1573a1e7afb24f66c282ab881e998c0278eb88.jpeg",
    "https://cdn.faire.com/fastly/53c3ceb74e36aa7cc973e6cc43f585fdc821fcdcd0c8113c629ebd45ba6f29da.jpeg",
    "https://cdn.faire.com/fastly/67eecfe46d947305e607fa80d29fa0b115e875354749d05219e6d0fe55be8b02.jpeg",
    "https://cdn.faire.com/fastly/fee43dfeb35f92398d27771f575db0ed207488419902eaebf2ee860c24c7cce1.jpeg",
    "https://cdn.faire.com/fastly/acf794a8b74a56aa7a3c50a86c7f507ef1f5faac7db8eff93e1bf2912c0b9e07.jpeg",
    "https://cdn.faire.com/fastly/a62444c1fcec6d654315cbbbd4faed4407e8e47d6438d9996ffb896efcb4814d.jpeg",
  ],
  priceDollars: 14.99,
  description:
    "Wholesale Discovery Kit at Tester Price - Please note we can only sell 1 kit per customer as this is to try the products out for future purchasing and they are not for re-sale. \n\nVegan Lip Care for Natural Beauty\nHydrate and tint your lips with our creamy vegan lip balms and buildable lip stains. Made with nourishing plant oils, our cruelty-free, plastic-free formulas deliver lasting moisture and vibrant color — clean beauty for everyday wear.\n\nIn the kit: 1 Bare Lip Balm + 2 Tinted Lip Balms + 1 Lip Stain \n\nWe have chosen a selection of Lip balms and Stains for different kits.",
  tags: [],
  msrpDollars: 29.98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:07.038Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
